import React, { useRef } from 'react';
var VeltNotificationsPanelContentAllList = function (props) {
    var listItemTemplate = props.listItemTemplate, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all-list", { ref: ref, "list-item-template": listItemTemplate ? (typeof listItemTemplate === 'string' ? listItemTemplate : JSON.stringify(listItemTemplate)) : undefined }, children));
};
export default VeltNotificationsPanelContentAllList;
